import { Sparkle } from "lucide-react";

const ITEMS = ["Mariages", "Soirées privées", "Séminaires", "Anniversaires", "Soirées d'entreprise"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <div key={item + (hidden ? "-b" : "-a")} className="flex items-center">
        <span className="font-display px-8 text-2xl font-extrabold uppercase tracking-wide text-slate-500 sm:text-3xl">
          {item}
        </span>
        <Sparkle size={16} className="shrink-0 text-cyan-400" />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      className="overflow-hidden border-y border-cyan-500/10 bg-[#0A101B] py-7"
      data-testid="marquee-section"
    >
      <div className="animate-marquee flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
